import { Box, CircularProgress, TextField, Typography } from '@mui/material';
import { useState } from 'react';

export const AddNodeInput = ({
  onSubmit,
  onCancel,
  isCreating,
}: {
  onSubmit: (name: string) => void;
  onCancel: () => void;
  isCreating: boolean;
}) => {
  const [name, setName] = useState('');

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    event.stopPropagation();
    if (event.key === 'Enter' && name.trim() && !isCreating) {
      onSubmit(name.trim());
    }
    if (event.key === 'Escape') {
      event.preventDefault();
      onCancel();
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.5, pl: 1 }}>
      <TextField
        size='small'
        placeholder='Name'
        value={name}
        onChange={event => setName(event.target.value)}
        onKeyDown={handleKeyDown}
        onKeyUp={event => {
          event.stopPropagation();
          if (event.key === 'Escape') onCancel();
        }}
        autoFocus
        disabled={isCreating}
        slotProps={{
          input: {
            endAdornment: isCreating ? <CircularProgress size={16} /> : undefined,
            sx: { fontSize: '0.875rem', height: 32 },
          },
        }}
        sx={{ width: 220 }}
      />
      <Typography variant='caption' color='text.secondary'>
        Enter to save, Esc to cancel
      </Typography>
    </Box>
  );
};
